import styled from "styled-components";
import { FaPlus, FaTrash } from "react-icons/fa";
import { Typography } from "antd";

export const StyledActionNode = styled.div<{ selected: boolean }>`
  background: ${({ theme, selected }) =>
    selected
      ? theme.palette.background.paper
      : theme.palette.background.secondary};
  border-radius: 50%;
  border: 2px solid
    ${({ theme, selected }) =>
      selected ? theme.palette.primary.main : theme.palette.borderColor};
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.01);
  overflow: hidden;
  cursor: help;
`;

export const StyledActionNodeContent = styled.div<{
  selected: boolean;
  width: number;
  height: number;
}>`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding-bottom: 15px;
  cursor: help;

  &:hover {
    .node-actions {
      display: flex;
    }
  }
`;

export const StyledNodeTitle = styled(Typography)`
  padding: 5px;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const StyledNodeDetail = styled(Typography.Text)`
  font-size: 18px;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  width: 80%;
`;

export const StyledNodeHover = styled.div`
  display: none;

  position: absolute;
  bottom: 2px;
  width: 100%;
  height: 20px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const StyledNodeAddButton = styled(FaPlus)`
  cursor: pointer;
`;

export const StyledNodeDeleteButton = styled(FaTrash)`
  cursor: pointer;
`;
